
/* =======================================
Cross-sell Image Quality Enhancer
======================================= */
function updateCrossSellImageQuality() {
  const crossSellBlock = document.querySelector('essential-upsell-cross-sell-app-block');

  if (!crossSellBlock) return;

  const crossSellObserver = new MutationObserver(() => {
    const images = crossSellBlock.querySelectorAll('[data-essential-upsell-element="image"]');
    if (!images.length) return;

    images.forEach((img) => {
      const src = img.getAttribute('src');
      if (!src) return;

      // Strip all existing query params, add width=768
      const cleanSrc = src.split('?')[0] + '?width=768';
      img.setAttribute('src', cleanSrc);
    });
  });

  crossSellObserver.observe(crossSellBlock, {
    childList: true,
    subtree: true,
  });
}

updateCrossSellImageQuality();
